import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import axios from "axios"; // Ensure this is the standard axios
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import SoftUIDashboard from "./soft-ui-dashboard";

// Import vue-i18n and language files
import { createI18n } from "vue-i18n";
import en from "./views/locales/en.json";
import hi from "./views/locales/hi.json";
import mr from "./views/locales/mr.json";

// ============================================================
// BULLETPROOF GLOBAL AXIOS INTERCEPTOR
// ============================================================

// 1. Request: Attach token to every call
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token') || 
                localStorage.getItem('auth_token') || 
                localStorage.getItem('admin_token');
  
  if (token) {
    config.headers.Authorization = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
  }
  return config;
}, (error) => Promise.reject(error));

// 2. Response: Catch 401 and FORCE redirect
axios.interceptors.response.use(
  (response) => response, 
  (error) => {
    // DEBUG: This will show in your F12 console if a 401 happens
    console.log("Global Interceptor caught an error:", error.response ? error.response.status : 'No Response');

    if (error.response && error.response.status === 401) {
      console.error("401 Unauthorized detected! Redirecting to /sign-in...");
      
      // Clear data
      //localStorage.clear();

      // Force jump to sign-in
      //window.location.href = "/sign-in"; 
    }
    return Promise.reject(error);
  }
);

// Assign to window so all components use the same modified instance
window.axios = axios; 
// ============================================================

const i18n = createI18n({
  locale: 'en', // Set default locale
  fallbackLocale: 'en', // Fallback language if the selected one is missing a translation
  messages: {
    en,
    hi,
    mr,
  },
});

import { hasPermission } from "./utils/permissions";

// Create the Vue app instance and apply the configurations
const appInstance = createApp(App);
appInstance.config.globalProperties.$hasPermission = hasPermission;
appInstance.use(store);
appInstance.use(router);
appInstance.use(SoftUIDashboard);
appInstance.use(i18n);

appInstance.mount("#app");